import CreateNotificacionDto from '../../domain/CreateNotificacionDto'
import UpdateNotificationDto from '../../domain/UpdateNotificationDto'
import Notificacion from '../../domain/Notificacion'

export default class NotificacionAdapter {
  static toDomain(notificacionDto) {
    return Notificacion.fromDto(notificacionDto)
  }

  static toDto(notificacion, dtoType, perfil) {
    if (dtoType === 'create') {
      return new CreateNotificacionDto(notificacion).toPrimitives()
    }

    if (dtoType === 'update') {
      return new UpdateNotificationDto(notificacion, perfil).toPrimitives()
    }
  }
}
